// @todo This component is not yet built. It should obtain the images from Instagram. Only the display is done at this time.
export default {
  name: 'instagram-component',

  computed: {
    feed () { return this.$store.getters.instagramFeed }
  },

  beforeMount () {
    this.$store.dispatch('loadInstagramFeed')
  }
}



// WEBPACK FOOTER //
// ./src/components/instagram/script.js